import { SVGAttributes } from 'react';

export const Credit = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="#0076BE"
        d="M5 6h17a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
      />
      <path
        d="M22 20.75H5a2 2 0 0 1-2-2V19a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-.25a2 2 0 0 1-2 2z"
        opacity=".1"
      />
      <path
        fill="#FFF"
        d="M22 6H5a2 2 0 0 0-2 2v.25a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2V8a2 2 0 0 0-2-2z"
        opacity=".2"
      />
      <path
        fill="#0277BD"
        d="M5 6h17a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
      />
      <path
        d="M22 20.75H5a2 2 0 0 1-2-2V19a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-.25a2 2 0 0 1-2 2z"
        opacity=".1"
      />
      <path
        fill="#FFF"
        d="M22 6H5a2 2 0 0 0-2 2v.25a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2V8a2 2 0 0 0-2-2z"
        opacity=".2"
      />
      <path fill="#303C42" d="M3 9h21v3H3z" />
      <path
        fill="#039BE5"
        d="M2 3h17a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
      />
      <path
        d="M19 17.75H2a2 2 0 0 1-2-2V16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-.25a2 2 0 0 1-2 2z"
        opacity=".1"
      />
      <path
        fill="#FFF"
        d="M19 3H2a2 2 0 0 0-2 2v.25a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2V5a2 2 0 0 0-2-2z"
        opacity=".2"
      />
      <path fill="#FFF" d="M3 11h6v1H3zM3 14h8v1H3z" />
      <circle cx="16" cy="13" r="2" fill="#FBB03B" />
      <circle cx="14" cy="13" r="2" fill="#FF6F00" />
      <path
        fill="#FF8F00"
        d="M15 11.277c-.595.347-1 .985-1 1.723 0 .738.405 1.376 1 1.723.595-.347 1-.985 1-1.723 0-.738-.405-1.376-1-1.723z"
      />
      <linearGradient
        id="a"
        x1="-.753"
        x2="24.663"
        y1="6.17"
        y2="18.022"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFF" stopOpacity=".2" />
        <stop offset="1" stopColor="#FFF" stopOpacity="0" />
      </linearGradient>
      <path
        fill="url(#a)"
        d="M22 6h-1V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h.5v1a2 2 0 0 0 2 2H22a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
      />
    </svg>
  );
};
